import { history } from '@umijs/max';
import { outLogin } from '@/services/ant-design-pro/api';

export const useLogout = (
    setInitialState: (state: any | ((prev: any) => any)) => void
) => {
    const logout = async () => {
        try {
            // 调用退出登录 API
            await outLogin();

            // 清除本地状态
            setInitialState((prev: any) => ({
                ...prev,
                currentUser: undefined,
                currentUserMenu: undefined,
                menuLastUpdated: undefined,
                showGoogle2FAModal: false,
            }));

            // 重定向到登录页面
            const { search, pathname } = window.location;
            const urlParams = new URL(window.location.href).searchParams;
            const searchParams = new URLSearchParams({
                redirect: pathname + search,
            });

            const redirect = urlParams.get('redirect');
            if (window.location.pathname !== '/user/login' && !redirect) {
                history.replace({
                    pathname: '/user/login',
                    search: searchParams.toString(),
                });
            }
        } catch (error) {
            console.error('Logout failed:', error);
            // 即使 API 调用失败，也要清除本地状态
            setInitialState((prev: any) => ({
                ...prev,
                currentUser: undefined,
                currentUserMenu: undefined,
                menuLastUpdated: undefined,
                showGoogle2FAModal: false,
            }));

            // 强制跳转到登录页面
            history.replace('/user/login');
        }
    };

    return { logout };
};
